// <menu-drawer>: mejora el menú <details> de la cabecera (§4.1).
// Sin JS el menú ya abre y cierra. Con JS: Escape cierra y devuelve el foco al botón,
// y el menú se cierra al hacer clic fuera o al sacar el foco con el teclado (no deja foco oculto, 2.4.11).
class MenuDrawer extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.details.open) {
        this.close();
        this.summary.focus();
      }
    });
    this.addEventListener('focusout', (event) => {
      if (this.details.open && event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    });
    this.onDocumentClick = (event) => {
      if (this.details.open && !this.contains(event.target)) this.close();
    };
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  close() {
    this.details.open = false;
  }
}

customElements.define('menu-drawer', MenuDrawer);
